/**
 * Generates an array of numbers from 0 to size
 */
export const range = (size: number) => [...Array(size).keys()];

export default range;
